export const PseudonymId = ({ value, record }) => (record.pseudonym) ? 'PSN-' + record.pseudonym.id : '';
